export default "__VITE_ASSET__335aaee0__"